import Skeleton from '@mui/material/Skeleton'
import type { Field } from '@pbt/pbt-ui-components'
import { TextInteractive } from '@pbt/pbt-ui-components'

import PuiSwitch from '~/components/common/PuiSwitch'

export const getDropOffPayload = (
  isDropOffEnabled: boolean,
  dropOffValue: unknown,
): Record<string, unknown> =>
  isDropOffEnabled ? { dropOff: Boolean(dropOffValue) } : {}

export interface DropOffCellProps {
  appointmentTypeDropOff?: boolean
  dropOff: Field | undefined
  isCreating: boolean
  isLoading: boolean
  isNewTypeFlow: boolean
  isTypeUpdating: boolean
  onlineSchedulingAllowed: Field
  t: (key: string) => string
}

export const DropOffCell = ({
  appointmentTypeDropOff,
  dropOff,
  isCreating,
  isLoading,
  isNewTypeFlow,
  isTypeUpdating,
  onlineSchedulingAllowed,
  t,
}: DropOffCellProps) => {
  if (isLoading) return <Skeleton height={30} width={40} />
  if (isNewTypeFlow && dropOff) {
    return (
      <PuiSwitch
        disabled={(isCreating && isNewTypeFlow) || isTypeUpdating}
        field={{
          ...dropOff,
          set: (event) => {
            const {
              target: { checked },
            } = event as React.ChangeEvent<HTMLInputElement>
            dropOff.set(event)
            if (checked) {
              onlineSchedulingAllowed.set({
                target: { checked: false },
              } as React.ChangeEvent<HTMLInputElement>)
            }
          },
        }}
        inputProps={{ 'aria-label': t('Common:DROP_OFF') }}
      />
    )
  }
  const label = appointmentTypeDropOff
    ? t('Admin:APPOINTMENT_CONFIGURATION.DROP_OFF_ALLOWED')
    : t('Admin:APPOINTMENT_CONFIGURATION.DROP_OFF_NOT_ALLOWED')
  return <TextInteractive isLoading={isLoading}>{label}</TextInteractive>
}
